import styles from "@/styles/shop-info/day-change-mind.module.scss";
import { Button } from 'antd';
import Image from "next/image";

import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();
const imageDomain = publicRuntimeConfig.imageDomain;

export default function CompDayChangeMindContent() {
  return (
    <div className={styles["comp-day-change-mind"]}>
      <Image
        className={styles["banner-img"]}
        style={{ display: "block", margin: "0 auto" }}
        src={`${imageDomain}/legal/day-change-mind-banner.png`}
        alt={"crazy-points-banner"}
        width={800}
        height={139}
      ></Image>
      <div className={`${styles["ask-title"]} padding-top-16`}>
        The CrazySales 30 Day Change-of-Mind Policy
      </div>
      <div className={`${styles["answer-desc"]}`}>
        Online shopping sometimes means you don&apos;t get exactly what you had in
        mind. You are welcome to return the item as long as you meet the
        following terms and conditions as listed below:
      </div>
      <div className={`${styles["ask-title"]} padding-top-16`}>
        Terms & Conditions
      </div>
      <div className={`${styles["answer-desc"]}`}>
        • Notification is required within 30 days of purchase date.
      </div>
      <div className={`${styles["answer-desc"]}`}>
        • Item to be returned must be in their original re-saleable condition
        with all tags and packaging (ready to be put back on the shelf).
      </div>
      <div className={`${styles["answer-desc"]}`}>
        • The item/s are NOT opened, used, worn or damaged.
      </div>
      <div className={`${styles["answer-desc"]}`}>
        • That you DO NOT stick or write anything on the item itself or its
        packaging. Please only write or place postage stickers on the outer
        postage packaging.
      </div>
      <div className={`${styles["answer-desc"]}`}>
        • Some items are not eligible for refund due to hygienic reasons.
      </div>
      <div className={`${styles["answer-desc"]}`}>
        • The refund amount will not include delivery costs. If the item was
        delivered for free, delivery cost will be deducted.
      </div>
      <div className={`${styles["answer-desc"]}`}>
        • Handling fees will apply at 20% of the purchase price.
      </div>
      <div className={`${styles["answer-desc"]}`}>
        • The return of the item is the responsibility of the buyer.
      </div>
      <div className={`${styles["answer-desc"]}`}>
        • If the item has sustained damage in transit or does not return as
        noted above, a revised refund amount may be required
      </div>
      <div className={`${styles["answer-desc"]}`}>
        If you would like to take this offer, please send us an email at
        info@crazysales.com.au and indicate the Order ID the item/s you wish to
        return and the reason for the return. Our Customer Service team will
        reply to your email and, if applicable, issue you a Return Authorization
        (RA) number. All other relevant information will be given to you at this
        time. Crazysales will not accept any return of any item/s without an RA
        from our Customer Service Representative.
      </div>
      <Button
        type="primary"
        href="/contact-us?q1=After%20Sales&q2=F7&nothappy=1"
        className={styles["continue-shopping-btn"]}
      >
        I Would Like to Claim This Policy
      </Button>
    </div>
  );
}
